import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./buses.module.scss";
import axios from "axios";
import { API_CONSTANTS } from "../../common/constants/api";
import { IBusItem } from "../../common/types";
import BannerCarousel from "../../components/BannerCarousel/BannerCarousel";
import { SESSION_KEYS } from "../../common/constants/sessionKeys";

const BusList = () => {
  const [searchParams] = useSearchParams();
  const [fromLoc, setFromLoc] = useState<string | undefined | null>();
  const [toLoc, setToLoc] = useState<string | undefined | null>();
  const [fromLocName, setFromLocName] = useState<string | undefined | null>();
  const [toLocName, setToLocName] = useState<string | undefined | null>();
  const [journeyDate, setJourneyDate] = useState<string | undefined | null>();
  const [buses, setBuses] = useState<IBusItem[]>([]);

  useEffect(() => {
    setFromLoc(searchParams.get("from"));
    setToLoc(searchParams.get("to"));
    setJourneyDate(searchParams.get("date"));
  }, [searchParams]);

  useEffect(() => {
    if (fromLoc && toLoc && journeyDate)
      axios
        .post(API_CONSTANTS.BUS_SEARCH, {
          fromStop: fromLoc,
          toStop: toLoc,
          searchDate: journeyDate,
        })
        .then((res) => {
          setBuses(res.data);
        });

    setFromLocName(sessionStorage.getItem(SESSION_KEYS.FROM_LOCATION));
    setToLocName(sessionStorage.getItem(SESSION_KEYS.TO_LOCATION));
  }, [fromLoc, toLoc, journeyDate]);
  return (
    <div className="container pageContainer">
      <div className="row">
        <div className="col-12 mt-5">
          <h3>
            Search result for : {fromLocName} to {toLocName}{" "}
          </h3>
        </div>
        <div className="col-8 mb-5">
          <h3>Date: {journeyDate} </h3>
        </div>
        <div className="col-4 mb-5 text-end">
          <a
            href={`/?from=${fromLoc}&to=${toLoc}&date=${journeyDate}`}
            className="btn btn-primary"
          >
            Modify Journey
          </a>
        </div>
        <div className="col-12 my-5">
          {/* Table for large screens */}
          <div className={styles.busTableWrapper}>
            <table className={`table ${styles.busTable}`}>
              <thead>
                <tr className={styles.busrowHeader}>
                  <th>Bus Name</th>
                  <th>Departure Time</th>
                  {/* <th>Arrival Time</th> */}
                  <th>Type</th>
                  <th>Price</th>
                  <th>Available Seats</th>
                  <th>Book</th>
                </tr>
              </thead>
              <tbody>
                {buses.map((bus: IBusItem) => (
                  <tr key={bus.busId} className={styles.busrow}>
                    <td>{bus.busName}</td>
                    <td>{bus.scheduleTime}</td>
                    {/* <td>{bus.arrival}</td> */}
                    <td>{bus.busType}</td>
                    <td>RS {bus.price}</td>
                    <td>{bus.seatsAvailable}</td>
                    <td>
                      <a
                        href={`/book?busId=${bus.busId}&busRouteMappingId=${bus.busRouteMappingId}&date=${journeyDate}&from=${bus.source}&to=${bus.destination}&busName=${bus.busName}`}
                        className={`btn ${
                          bus.seatsAvailable === 0
                            ? "btn-secondary disabled"
                            : "btn-primary"
                        }`}
                      >
                        Book
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Cards for tablet/small screens */}
          <div className={styles.busCardWrapper}>
            {buses.map((bus: IBusItem) => (
              <div key={bus.busId} className={styles.busCard}>
                <div className={styles.busCardRow}>
                  <strong>Bus Name:</strong> {bus.busName}
                </div>
                <div className={styles.busCardRow}>
                  <strong>Departure Time:</strong> {bus.scheduleTime}
                </div>
                {/* <div className={styles.busCardRow}><strong>Arrival Time:</strong> {bus.arrival}</div> */}
                <div className={styles.busCardRow}>
                  <strong>Type:</strong> {bus.busType}
                </div>
                <div className={styles.busCardRow}>
                  <strong>Price:</strong> RS {bus.price}
                </div>
                <div className={styles.busCardRow}>
                  <strong>Available Seats:</strong> {bus.seatsAvailable}
                </div>
                <div className={styles.busCardRow}>
                  <a
                    href={`/book?busId=${bus.busId}&busRouteMappingId=${bus.busRouteMappingId}&date=${journeyDate}&from=${bus.source}&to=${bus.destination}&busName=${bus.busName}`}
                    className={`btn ${
                      bus.seatsAvailable === 0
                        ? "btn-secondary disabled"
                        : "btn-primary"
                    }`}
                  >
                    Book
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="col-12 my-5">
          {/* <BannerCarousel /> */}
        </div>
      </div>
    </div>
  );
};

export default BusList;
